module.exports = __webpack_public_path__ + "files/dcf63567070598d5f44cd7a878972a36.png";